import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import { TableContainerWrapper } from './TaskComponentStyled';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, TextField } from "@mui/material";
import { red } from '@mui/material/colors';
import Typography from '@mui/material/Typography';
export const TaskComponentTable = ({ headers, rows, isEditable, handleChange, error }) => {

    // Generate a mapping of taskId to column index
    const taskIndexMap = Object.fromEntries(headers.map((header, index) => [header.id, index]));

    // Create a matrix to store the data in the desired structure
    const tableData = [];
    rows.forEach((item) => {
        const rowIndex = tableData.findIndex((row) => row && row.componentId === item.componentId);
        if (rowIndex === -1) {
            const newRow = { countryId: item.countryId, componentId: item.componentId, componentName: item.componentName, tasks: headers.map((header) => ({ taskId: header.id, costMin: 0, isComponentExist: false,})), };
            newRow.tasks[taskIndexMap[item.taskId]] = { taskId: item.taskId, costMin: item.costMin, isComponentExist: true, };
            tableData.push(newRow);
        } else {
            tableData[rowIndex].tasks[taskIndexMap[item.taskId]] = { taskId: item.taskId, costMin: item.costMin, isComponentExist: true };
        }
        //console.log(`Table Data: ${rowIndex}`, tableData);
    });

    const GetValue = function getUtilValue(countryId, componentId, id) {
        const filterIndex = error?.findIndex(item => item.countryId == countryId && item.componentId === componentId && item.errorField === id);
        if (filterIndex !== -1) {
            return error[filterIndex].errorMessage;
        }
    }

    return (
        <TableContainerWrapper component={Paper}>
            <Table sx={{ minWidth: "400" }} aria-label="customized table">
                <TableHead sx={{ borderBottom: "2px solid #1B4A83" }}>
                    <TableRow >
                        <TableCell rowSpan={2}>Component</TableCell>
                        <TableCell className="taskrow" colSpan={headers?.length} >Task</TableCell>
                    </TableRow>
                    <TableRow>
                        {headers.map((header, index) => (

                            <TableCell key={header.id}>{header.taskName} {rows?.find(x=>x.taskId==header.id)?.currencyCode?`(${rows?.find(x=>x.taskId==header.id)?.currencyCode})`:''}</TableCell>
                        ))}

                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableData.map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                            <TableCell>{row.componentName}</TableCell>
                            {row.tasks.map((task, taskIndex) => (
                                <TableCell key={taskIndex}>
                                    {(task) ?
                                        isEditable && task.isComponentExist ?
                                            <>
                                                <TextField
                                                    size="small"
                                                    defaultValue={task.costMin}
                                                    onChange={(e) => handleChange(row.componentId, task.taskId, row.countryId, e.target.value)}
                                                />
                                                  {GetValue(row.countryId, row.componentId,  task.taskId)?
                                                < Typography variant="caption" sx={{ color: red[500],fontSize:'10px',whiteSpace:'nowrap' }} display="block" gutterBottom>
                                                  {GetValue(row.countryId, row.componentId,  task.taskId)}
                                            </Typography>:
                                               
                                           
                                   <div style={{height:"20px"}}></div> } 
                                            </> :
                                            Number(task.costMin.toFixed(2)).toLocaleString("en", { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 }) : 0}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainerWrapper>
    );
};

export default TaskComponentTable;